/* eslint-disable react/jsx-key */
// routes

import { PATH_DASHBOARD } from '../../../routes/paths';
// components

import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

// eslint-disable-next-line import/no-mutable-exports
let navConfig = '';
// let usertypes = [];
const getIcon = (name) => <SvgIconStyle src={`/logo/${name}.png`} sx={{ width: 1, height: 1 }} />;
const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  video:getIcon('ic_video'),
  coachreview:getIcon('ic_coachreview'),
  videoreview:getIcon('ic_videoreview:'),
  audioreview:getIcon('ic_audioreview')

};


 const usertype = window.localStorage.getItem('user_type');

// const [usertype, setUserType] = useState(window.localStorage.getItem('user_type'))
const userid = window.localStorage.getItem('user_id');

if (usertype === '2'|| usertype === 2 ) {
console.log("usertype1");
  navConfig = [
    // AUTHOR

    // ----------------------------------------------------------------------
  
    {
     
      subheader: 'author',

      items: [
         
        { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
        { title: 'author', path: PATH_DASHBOARD.general.author, icon: ICONS.user },
        { title: 'book', path: PATH_DASHBOARD.general.book, icon: ICONS.booking },
        { title: 'book Review', path: PATH_DASHBOARD.general.bookreview, icon: ICONS.blog },
        { title: 'author review', path: PATH_DASHBOARD.general.authorreview, icon: ICONS.analytics },
      ],
    },
  ];
}

// COACH
// ----------------------------------------------------------------------
else if (usertype === '3'|| usertype === 3) 
{
  console.log("usertype2");
  navConfig = [
  
    {
      
      subheader: 'coach',
    
    
      items: [
        { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
        { title: 'coach', path: PATH_DASHBOARD.general.coach, icon: ICONS.calendar },
        { title: 'audio', path: PATH_DASHBOARD.general.audio, icon: ICONS.ecommerce },
        { title: 'video', path: PATH_DASHBOARD.general.video, icon: ICONS.video },
        { title: 'coach review', path: PATH_DASHBOARD.general.coachreview, icon: ICONS.coachreview },
        { title: 'audio review', path: PATH_DASHBOARD.general.audioreview, icon: ICONS.audioreview },
        { title: 'video review', path: PATH_DASHBOARD.general.videoreview, icon: ICONS.kanban },
      ],
    },
  ];
} else {
  
  navConfig = [
    // AUTHOR

    // ----------------------------------------------------------------------

    {
      subheader: 'coach',

      items: [
       
      
        { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
        { title: 'coach', path: PATH_DASHBOARD.general.coach, icon: ICONS.calendar },
        { title: 'audio', path: PATH_DASHBOARD.general.audio, icon: ICONS.ecommerce },
        { title: 'video', path: PATH_DASHBOARD.general.video, icon: ICONS.video },
        { title: 'coach review', path: PATH_DASHBOARD.general.coachreview, icon: ICONS.coachreview },
        { title: 'audio review', path: PATH_DASHBOARD.general.audioreview, icon: ICONS.audioreview },
        { title: 'video review', path: PATH_DASHBOARD.general.videoreview, icon: ICONS.kanban },
      ],
    },
    {
      subheader: 'author',

      items: [
  
      
        { title: 'author', path: PATH_DASHBOARD.general.author, icon: ICONS.user },
        { title: 'book', path: PATH_DASHBOARD.general.book, icon: ICONS.booking },
        { title: 'book Review', path: PATH_DASHBOARD.general.bookreview, icon: ICONS.blog },
        { title: 'author review', path: PATH_DASHBOARD.general.authorreview, icon: ICONS.analytics },
     
      
      ],


     
    },
  ];
}



export default navConfig;
export function test111 (){
  const usertype = window.localStorage.getItem('user_type');
  if (usertype === '2'|| usertype === 2 ) {
    console.log("usertype1");
      navConfig = [
        // AUTHOR
    
        // ----------------------------------------------------------------------
      
        {
         
          subheader: 'author',
    
          items: [
             
            { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
            { title: 'author', path: PATH_DASHBOARD.general.author, icon: ICONS.user },
            { title: 'book', path: PATH_DASHBOARD.general.book, icon: ICONS.booking },
            { title: 'book Review', path: PATH_DASHBOARD.general.bookreview, icon: ICONS.blog },
            { title: 'author review', path: PATH_DASHBOARD.general.authorreview, icon: ICONS.analytics },
          ],
        },
      ];
    }
    
    // COACH
    // ----------------------------------------------------------------------
    else if (usertype === '3'|| usertype === 3) 
    {
      console.log("usertype2");
      navConfig = [
      
        {
          
          subheader: 'coach',
        
        
          items: [
            { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
            { title: 'coach', path: PATH_DASHBOARD.general.coach, icon: ICONS.calendar },
            { title: 'audio', path: PATH_DASHBOARD.general.audio, icon: ICONS.ecommerce },
            { title: 'video', path: PATH_DASHBOARD.general.video, icon: ICONS.video },
            { title: 'coach review', path: PATH_DASHBOARD.general.coachreview, icon: ICONS.coachreview },
            { title: 'audio review', path: PATH_DASHBOARD.general.audioreview, icon: ICONS.audioreview },
            { title: 'video review', path: PATH_DASHBOARD.general.videoreview, icon: ICONS.kanban },
          ],
        },
      ];
    } else {
     
      navConfig = [
        // AUTHOR
    
        // ----------------------------------------------------------------------
    
        {
          subheader: 'coach',
    
          items: [
           
          
            { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
            { title: 'coach', path: PATH_DASHBOARD.general.coach, icon: ICONS.calendar },
            { title: 'audio', path: PATH_DASHBOARD.general.audio, icon: ICONS.ecommerce },
            { title: 'video', path: PATH_DASHBOARD.general.video, icon: ICONS.video },
            { title: 'coach review', path: PATH_DASHBOARD.general.coachreview, icon: ICONS.coachreview },
            { title: 'audio review', path: PATH_DASHBOARD.general.audioreview, icon: ICONS.audioreview },
            { title: 'video review', path: PATH_DASHBOARD.general.videoreview, icon: ICONS.kanban },
          ],
        },
        {
          subheader: 'author',
    
          items: [
      
          
            { title: 'author', path: PATH_DASHBOARD.general.author, icon: ICONS.user },
            { title: 'book', path: PATH_DASHBOARD.general.book, icon: ICONS.booking },
            { title: 'book Review', path: PATH_DASHBOARD.general.bookreview, icon: ICONS.blog },
            { title: 'author review', path: PATH_DASHBOARD.general.authorreview, icon: ICONS.analytics },
         
          
          ],
    
    
         
        },
      ];
    }
  return navConfig
}